/**
 * 所有db共用的缓存数据放cache
 */
export const tradeSectionGrp = {
  SS: {
    trade_section_grp: [{
      open_time: 930,
      close_time: 1130
    }, {
      open_time: 1300,
      close_time: 1500
    }],
    axisX: ['09:30', '11:30/13:00', '15:00'],
    axisXNew: ['09:30', '10:00', '10:30', '11:00', '11:30/13:00', '13:30', '14:00', '14:30', '15:00'],
    singleAmount: 240,
    fiveAmount: 1200,
    inAmerica: false
  },
  XSHG: {
    trade_section_grp: [{
      open_time: 930,
      close_time: 1130
    }, {
      open_time: 1300,
      close_time: 1500
    }],
    axisX: ['09:30', '11:30/13:00', '15:00'],
    axisXNew: ['09:30', '10:00', '10:30', '11:00', '11:30/13:00', '13:30', '14:00', '14:30', '15:00'],
    singleAmount: 240,
    fiveAmount: 1200,
    inAmerica: false
  },
  SZ: {
    trade_section_grp: [{
      open_time: 930,
      close_time: 1130
    }, {
      open_time: 1300,
      close_time: 1500
    }],
    axisX: ['09:30', '11:30/13:00', '15:00'],
    axisXNew: ['09:30', '10:00', '10:30', '11:00', '11:30/13:00', '13:30', '14:00', '14:30', '15:00'],
    singleAmount: 240,
    fiveAmount: 1200,
    inAmerica: false
  },
  XSHE: {
    trade_section_grp: [{
      open_time: 930,
      close_time: 1130
    }, {
      open_time: 1300,
      close_time: 1500
    }],
    axisX: ['09:30', '11:30/13:00', '15:00'],
    axisXNew: ['09:30', '10:00', '10:30', '11:00', '11:30/13:00', '13:30', '14:00', '14:30', '15:00'],
    singleAmount: 240,
    fiveAmount: 1200,
    inAmerica: false
  },
  XBHS: {
    trade_section_grp: [{
      open_time: 930,
      close_time: 1130
    }, {
      open_time: 1300,
      close_time: 1500
    }],
    axisX: ['09:30', '11:30/13:00', '15:00'],
    axisXNew: ['09:30', '10:00', '10:30', '11:00', '11:30/13:00', '13:30', '14:00', '14:30', '15:00'],
    singleAmount: 240,
    fiveAmount: 1200,
    inAmerica: false
  },
  CNI: {
    trade_section_grp: [{
      open_time: 930,
      close_time: 1130
    }, {
      open_time: 1300,
      close_time: 1500
    }],
    axisX: ['09:30', '11:30/13:00', '15:00'],
    axisXNew: ['09:30', '10:00', '10:30', '11:00', '11:30/13:00', '13:30', '14:00', '14:30', '15:00'],
    singleAmount: 240,
    fiveAmount: 1200,
    inAmerica: false
  },
  GZZS: {
    trade_section_grp: [{
      open_time: 930,
      close_time: 1130
    }, {
      open_time: 1300,
      close_time: 1500
    }],
    axisX: ['09:30', '11:30/13:00', '15:00'],
    axisXNew: ['09:30', '10:00', '10:30', '11:00', '11:30/13:00', '13:30', '14:00', '14:30', '15:00'],
    singleAmount: 240,
    fiveAmount: 1200,
    inAmerica: false
  },
  CSI: {
    trade_section_grp: [{
      open_time: 930,
      close_time: 1130
    }, {
      open_time: 1300,
      close_time: 1500
    }],
    axisX: ['09:30', '11:30/13:00', '15:00'],
    axisXNew: ['09:30', '10:00', '10:30', '11:00', '11:30/13:00', '13:30', '14:00', '14:30', '15:00'],
    singleAmount: 240,
    fiveAmount: 1200,
    inAmerica: false
  },
  ZZZS: {
    trade_section_grp: [{
      open_time: 930,
      close_time: 1130
    }, {
      open_time: 1300,
      close_time: 1500
    }],
    axisX: ['09:30', '11:30/13:00', '15:00'],
    axisXNew: ['09:30', '10:00', '10:30', '11:00', '11:30/13:00', '13:30', '14:00', '14:30', '15:00'],
    singleAmount: 240,
    fiveAmount: 1200,
    inAmerica: false
  },
  NEEQ: {
    trade_section_grp: [{
      open_time: 930,
      close_time: 1130
    }, {
      open_time: 1300,
      close_time: 1500
    }],
    axisX: ['09:30', '11:30/13:00', '15:00'],
    axisXNew: ['09:30', '10:00', '10:30', '11:00', '11:30/13:00', '13:30', '14:00', '14:30', '15:00'],
    singleAmount: 240,
    fiveAmount: 1200,
    inAmerica: false
  },
  XSB: {
    trade_section_grp: [{
      open_time: 930,
      close_time: 1130
    }, {
      open_time: 1300,
      close_time: 1500
    }],
    axisX: ['09:30', '11:30/13:00', '15:00'],
    axisXNew: ['09:30', '10:00', '10:30', '11:00', '11:30/13:00', '13:30', '14:00', '14:30', '15:00'],
    singleAmount: 240,
    fiveAmount: 1200,
    inAmerica: false
  },
  SHO: {
    trade_section_grp: [{
      open_time: 930,
      close_time: 1130
    }, {
      open_time: 1300,
      close_time: 1500
    }],
    axisX: ['09:30', '11:30/13:00', '15:00'],
    axisXNew: ['09:30', '10:00', '10:30', '11:00', '11:30/13:00', '13:30', '14:00', '14:30', '15:00'],
    singleAmount: 240,
    fiveAmount: 1200,
    inAmerica: false
  },
  XSHO: {
    trade_section_grp: [{
      open_time: 930,
      close_time: 1130
    }, {
      open_time: 1300,
      close_time: 1500
    }],
    axisX: ['09:30', '11:30/13:00', '15:00'],
    axisXNew: ['09:30', '10:00', '10:30', '11:00', '11:30/13:00', '13:30', '14:00', '14:30', '15:00'],
    singleAmount: 240,
    fiveAmount: 1200,
    inAmerica: false
  },
  HKM: {
    trade_section_grp: [{
      open_time: 930,
      close_time: 1200
    }, {
      open_time: 1300,
      close_time: 1600
    }],
    axisX: ['09:30', '12:00/13:00', '16:00'],
    axisXNew: ['09:30', '10:00', '10:30', '11:00','11:30', '12:00/13:00', '13:30', '14:00', '14:30','15:00','15:30', '16:00'],
    singleAmount: 330,
    fiveAmount: 1200,
    inAmerica: false
  }
};
export const setSectionGrp = (key, value) => {
  tradeSectionGrp[key] = value;
};
